import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export default function useQueryValue(key: string) {
  const { search } = useLocation()

  return useMemo(() => new URLSearchParams(search).get(key), [key, search])
}
